/**
 * React dependencies
 */
import React, { useContext, useEffect, useState } from 'react';

/**
 * DWT dependencies
 */
import useTeamMemberFilterCheckbox from '../hooks/useTeamMemberFilterCheckbox';
import { TeamMemberGridContext } from '../../TeamMemberGrid/TeamMemberGridContext';

/**
  * DWT components
*/
import FilterItem from './FilterItem';

const TeamMemberGridFilter = ({ filterType, dataCode, title }) => {
  const [ isActive, setIsActive ] = useState( false );
  const { filterOptions } = useContext( TeamMemberGridContext );

  const {
    checkedFilter,
    handleCheckboxChange,
    setChecked,
    resetContextFilter,
    initialObj,
  } = useTeamMemberFilterCheckbox( filterType );

  useEffect( () => {
    const gridEl = document.querySelector( '.team-member-grid' );
    if ( gridEl ) {
      gridEl.setAttribute(
        dataCode,
        Object.keys( checkedFilter ).filter( ( k ) => checkedFilter[k] ).join( ' ' )
      );
    }
  }, [ checkedFilter, dataCode ] );

  if ( !filterOptions[filterType] || !filterOptions[filterType].length ) {
    return null;
  }

  return (
    <FilterItem
      filterType={ filterType }
      data={ filterOptions[ filterType ] }
      dataCode={ dataCode }
      title={ title }
      isActive={ isActive }
      setIsActive={ setIsActive }
      checked={ checkedFilter }
      setChecked={ setChecked }
      handleFilter={ handleCheckboxChange }
      resetContextFilter={ resetContextFilter }
      initialObj={ initialObj } 
    />
  );
};

export default TeamMemberGridFilter;
